<template>
    <div class="authed-offer-sent-container">
        <div class="info-top">
            <p class="title">All set!</p>
            <div class="messages">
                <div v-for="message in messages" :key="message.text" class="message">
                    <img :src="message.icon" alt="check-mark" />
                    <p class="message-text">{{ message.text }}</p>
                </div>
            </div>
        </div>
        <div class="info-bottom">
            <p class="desc">
                When venue reviews to your offer you will see updates in Booking Manager
            </p>
            <a class="booking-link" href="/booking-manager">Go to Booking Manager</a>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'AuthedOfferSent',
        props: {
            opportunityInfo: {
                type: Object,
                required: true
            }
        },
        computed: {
            messages() {
                return [
                    {
                        icon: '/images/icons/checkmark-grey.svg',
                        text: `Your offer has been sent to ${this.opportunityInfo.venue_name}`
                    }
                ]
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .authed-offer-sent-container {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 40px;

        .info-top {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 8px;

            .title {
                color: #dedede;
                @include base-font-24;
                font-weight: 600;
                line-height: 28px;
            }
            .messages {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
                gap: 8px;

                .message {
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: flex-start;
                    gap: 8px;

                    img {
                        width: 24px;
                        height: 24px;
                        object-fit: cover;
                    }
                    .message-text {
                        color: var(--Neutral-400, #8b8b8b);
                        @include base-font-16;
                        font-weight: 400;
                        line-height: 24px;
                        text-wrap: wrap;
                    }
                }
            }
        }
        .info-bottom {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            gap: 24px;

            .desc {
                color: #8b8b8b;
                @include base-font-16;
                font-weight: 400;
                line-height: 24px;
            }
            .booking-link {
                max-width: 188px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 8px 16px;
                border-radius: 120px;
                border: 1px solid #cdeb09;
                color: #cdeb09;
                @include base-font-14;
                line-height: 115%;
                letter-spacing: 0.14px;
                text-decoration: none;
                text-wrap: nowrap;
            }
        }
    }
</style>
